// Aplankytos vietos (localStorage). LAIKINA: lokalu, be paskyros/sinchronizacijos.
// Nuotraukos saugomos atskirai (IndexedDB, žr. nuotrauku_saugykla.js).

const RAKTAS = 'aplankytos_vietos'

export function getAplankytos() {
  try {
    const r = localStorage.getItem(RAKTAS)
    return r ? JSON.parse(r) : []
  } catch {
    return []
  }
}

export function arAplankyta(id) {
  return getAplankytos().some(v => v.id === id)
}

// Prideda aplankytą vietą. km — atstumas nuo vartotojo tuo metu (jei žinomas).
// turiNuotrauka — ar išsaugota įrodymo nuotrauka.
export function pridetiAplankyta(vieta, { km = null, turiNuotrauka = false } = {}) {
  try {
    const sarasas = getAplankytos()
    if (sarasas.some(v => v.id === vieta.id)) return sarasas
    const irasas = {
      id: vieta.id,
      pavadinimas: vieta.pavadinimas,
      kategorija: vieta.kategorija,
      regionas: vieta.regionas || null,
      miestas: vieta.miestas || null,
      latitude: vieta.latitude,
      longitude: vieta.longitude,
      nuotrauka_url: vieta.nuotraukos?.[0] || vieta.nuotrauka_url || null,
      km: km != null ? Math.round(km) : null,
      turiNuotrauka: !!turiNuotrauka,
      data: Date.now(),
    }
    const naujas = [irasas, ...sarasas]
    localStorage.setItem(RAKTAS, JSON.stringify(naujas))
    return naujas
  } catch {
    return getAplankytos()
  }
}
